import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

//Calendar
import CalendarReducer from "./calendar/reducer";
//Chat
import chatReducer from "./chat/reducer";
//Ecommerce
import EcommerceReducer from "./ecommerce/reducer";

//Project
import ProjectsReducer from "./projects/reducer";

// Tasks
import TasksReducer from "./tasks/reducer";

//Crypto
import CryptoReducer from "./crypto/reducer";

//TicketsList
import TicketsReducer from "./tickets/reducer";
//Crm
import CrmReducer from "./crm/reducer";

//Invoice
import InvoiceReducer from "./invoice/reducer";

//Mailbox
import MailboxReducer from "./mailbox/reducer";

// Dashboard Analytics
import DashboardAnalyticsReducer from "./dashboardAnalytics/reducer";

// Dashboard CRM
import DashboardCRMReducer from "./dashboardCRM/reducer";

// Dashboard Ecommerce
import DashboardEcommerceReducer from "./dashboardEcommerce/reducer";

// Dashboard Cryto
import DashboardCryptoReducer from "./dashboardCrypto/reducer";

// Dashboard Cryto
import DashboardProjectReducer from "./dashboardProject/reducer";

// Dashboard NFT
import DashboardNFTReducer from "./dashboardNFT/reducer";

// Pages > Team
import TeamDataReducer from "./team/reducer";

// File Manager
import FileManagerReducer from "./fileManager/reducer";

// To do
import TodosReducer from "./todos/reducer";

// Job
import JobReducer from "./jobs/reducer";

// API Key
import APIKeyReducer from "./apiKey/reducer";

//BotList.
import BotListReducer from  './Bots/BotList/reducer'

import GroupListReducer from './groups/reducer'

import GroupOwnwerReducer from './Owner_Group/reducer'

import SidebarCust from "./SideBarCust/reducer";

import BotDetails from "./BotDetails/reduders"

import Bot_Thread from "./Thread/reducer"

import Confirm_Modal_Slice from './Confirm_Modal/reducer';

import Success_Modal from './Success_Modal/reducer';


import Error_Modal from './Error_Modal/reducer'

import Chat_History from './Chat_Cust/reducer'

import Create_Bot from './Create_New_bot/reducer'

import Favourite_Prompt from './Favourite_Prompt/reducer'

import Select_DB_Modal from './Select_DB_Modal/reducer'

import Table_Details from './Table_Details/reducer'

import Plans from './plans/reducer'

import Header from './header/reducer'

import WorkFlowBuilder from './workflow_builder/reducer'

import Dashboard from './dashboard/reducer'

import SharePoint from "./share_point/reducer";


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Calendar: CalendarReducer,
    Chat: chatReducer,
    Projects: ProjectsReducer,
    Ecommerce: EcommerceReducer,
    Tasks: TasksReducer,
    Crypto: CryptoReducer,
    Tickets: TicketsReducer,
    Crm: CrmReducer,
    Invoice: InvoiceReducer,
    Mailbox: MailboxReducer,
    DashboardAnalytics: DashboardAnalyticsReducer,
    DashboardCRM: DashboardCRMReducer,
    DashboardEcommerce: DashboardEcommerceReducer,
    DashboardCrypto: DashboardCryptoReducer,
    DashboardProject: DashboardProjectReducer,
    DashboardNFT: DashboardNFTReducer,
    Team: TeamDataReducer,
    FileManager: FileManagerReducer,
    Todos: TodosReducer,
    Jobs: JobReducer,
    APIKey: APIKeyReducer,
    Bot_List: BotListReducer,
    Group_List: GroupListReducer,
    GroupOwner:GroupOwnwerReducer,
    SidebarCust:SidebarCust,
    BotDetails:BotDetails,
    Threads:Bot_Thread,
    Confirm_Modal_Slice:Confirm_Modal_Slice,
    Success_Modal:Success_Modal,
    Error_Modal:Error_Modal,
    Chat_History:Chat_History,
    Create_Bot:Create_Bot,
    Favourite_Prompt:Favourite_Prompt,
    Select_DB_Modal:Select_DB_Modal,
    Table_Details:Table_Details,
    Plans:Plans,
    Header,
    WorkFlowBuilder,
    Dashboard,
    SharePoint
});

export default rootReducer;